import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LoginForm } from '../components/forms/login-form';
import { ThemeToggle } from '../components/ui/theme-toggle';

export const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-canvas flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative">
      {/* Barra superior de retorno */}
      <div className="absolute top-4 left-4 sm:top-6 sm:left-6 flex items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-neutral-600 dark:text-neutral-400 hover:text-brand-primary dark:hover:text-brand-primary p-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Volver al Sitio Público</span>
        </Link>
      </div>

      <div className="absolute top-4 right-4 sm:top-6 sm:right-6">
        <ThemeToggle />
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        {/* Logo Oficial BARTECH */}
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-brand-primary flex items-center justify-center text-white font-extrabold text-3xl shadow-sm">
            B
          </div>
          <div className="flex flex-col text-left">
            <div className="flex items-baseline font-black tracking-tight text-2xl leading-none">
              <span className="text-brand-primary">BAR</span>
              <span className="text-neutral-900 dark:text-white">TECH</span>
            </div>
            <span className="text-[10px] font-bold uppercase tracking-widest text-neutral-500 dark:text-neutral-400 mt-0.5">
              Portal de Administración
            </span>
          </div>
        </div>

        <h2 className="text-2xl font-bold tracking-tight text-neutral-900 dark:text-white">
          Panel Administrativo
        </h2>
        <p className="mt-1 text-xs sm:text-sm text-neutral-500 dark:text-neutral-400">
          Ingresa con tus credenciales institucionales
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0">
        <div className="bg-white dark:bg-neutral-900 py-8 px-6 shadow-sm border border-neutral-200 dark:border-neutral-800 rounded-2xl sm:px-10">
          <LoginForm />
        </div>

        <div className="mt-6 text-center text-xs text-neutral-400 dark:text-neutral-500">
          BARTECH Tecnología e Ingeniería SpA • Acceso Autorizado
        </div>
      </div>
    </div>
  );
};
